import { runInAction } from "mobx";

import { DirectChatsStore } from "@/store/DirectChatsStore";
import { useStore } from "@/store/RootStoreProvider";

export function useDirectChats(): DirectChatsStore {
  const rootStore = useStore();

  if (!rootStore.directChats) {
    runInAction(() => {
      if (!rootStore.directChats) {
        rootStore.directChats = new DirectChatsStore(rootStore);
      }
    });
  }

  return rootStore.directChats!;
}
